"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptionTypeValues = exports.EncryptionType = void 0;
var EncryptionType;
(function (EncryptionType) {
    EncryptionType["USER_NOTIFICATION_SETTINGS_TOKEN"] = "USER_NOTIFICATION_SETTINGS_TOKEN";
    EncryptionType["CHECK_IN_ID"] = "CHECK_IN_ID";
})(EncryptionType = exports.EncryptionType || (exports.EncryptionType = {}));
exports.EncryptionTypeValues = Object.values(EncryptionType);
